// import { get } from "lodash-es";

export const parser_forgot_password_request = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_reset_password = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_get_company_process = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_get_company_process_stage = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_get_user_company = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};
export const parser_change_password = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_register = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_company_details_by_domain = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const parser_get_users = (response) => {
  try {
    if (response?.data) {
      return response.data;
    }
    return response || [];
  } catch (error) {
    throw new Error(error);
  }
};